import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=70e726bc&scoped=true"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=70e726bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e726bc",
  null
  
)

export default component.exports